import { render, staticRenderFns } from "./PaymentAttachmentForm.vue?vue&type=template&id=289e7626&"
import script from "./PaymentAttachmentForm.vue?vue&type=script&lang=js&"
export * from "./PaymentAttachmentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports